var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUv = function SvgUv(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "uv_svg2__a",
    x1: 18.17,
    x2: 176.17,
    y1: 179.24,
    y2: 26.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#uv_svg2__a",
    id: "uv_svg2__b",
    x1: -25.04,
    x2: 132.96,
    y1: 134.62,
    y2: -18.38
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#uv_svg2__a",
    id: "uv_svg2__c",
    x1: 61.38,
    x2: 219.38,
    y1: 223.87,
    y2: 70.87
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#uv_svg2__a",
    id: "uv_svg2__d",
    x1: 60.02,
    x2: 218.02,
    y1: 222.45,
    y2: 69.45
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#uv_svg2__a",
    id: "uv_svg2__e",
    x1: -23.68,
    x2: 134.32,
    y1: 136.03,
    y2: -16.97
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#uv_svg2__a",
    id: "uv_svg2__f",
    x1: -40.18,
    x2: 117.82,
    y1: 118.99,
    y2: -34.01
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#uv_svg2__a",
    id: "uv_svg2__g",
    x1: 76.52,
    x2: 234.52,
    y1: 239.49,
    y2: 86.49
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#uv_svg2__a",
    id: "uv_svg2__h",
    x1: 32.8,
    x2: 190.8,
    y1: 194.35,
    y2: 41.35
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#uv_svg2__a",
    id: "uv_svg2__i",
    x1: 3.54,
    x2: 161.54,
    y1: 164.13,
    y2: 11.13
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#uv_svg2__a",
    id: "uv_svg2__j",
    x1: -39.68,
    x2: 118.32,
    y1: 119.5,
    y2: -33.5
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#uv_svg2__a",
    id: "uv_svg2__k",
    x1: 76.02,
    x2: 234.02,
    y1: 238.98,
    y2: 85.98
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#uv_svg2__a",
    id: "uv_svg2__l",
    x1: 1.67,
    x2: 159.67,
    y1: 162.2,
    y2: 9.2
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#uv_svg2__a",
    id: "uv_svg2__m",
    x1: 34.67,
    x2: 192.67,
    y1: 196.28,
    y2: 43.28
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#uv_svg2__a",
    id: "uv_svg2__n",
    x1: 25.04,
    x2: 183.04,
    y1: 186.34,
    y2: 33.34
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#uv_svg2__a",
    id: "uv_svg2__o",
    x1: 6.38,
    x2: 164.38,
    y1: 167.06,
    y2: 14.06
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M100 167.1c-37 0-67.1-30.1-67.1-67.1S63 32.91 100 32.91s67.1 30.1 67.1 67.1-30.1 67.1-67.1 67.1m0-122.45c-30.52 0-55.34 24.83-55.34 55.34s24.82 55.34 55.34 55.34 55.34-24.83 55.34-55.34S130.52 44.66 100 44.66",
    style: {
      fill: "url(#uv_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100 27.06c-3.25 0-5.88-2.63-5.88-5.88V5.88C94.12 2.63 96.75 0 100 0s5.88 2.63 5.88 5.88v15.3c0 3.24-2.63 5.88-5.88 5.88",
    style: {
      fill: "url(#uv_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100 200c-3.25 0-5.88-2.63-5.88-5.88v-15.3c0-3.24 2.63-5.88 5.88-5.88s5.88 2.63 5.88 5.88v15.3c0 3.24-2.63 5.88-5.88 5.88",
    style: {
      fill: "url(#uv_svg2__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.12 105.88h-15.3c-3.25 0-5.88-2.63-5.88-5.88s2.63-5.88 5.88-5.88h15.3c3.25 0 5.88 2.63 5.88 5.88s-2.63 5.88-5.88 5.88",
    style: {
      fill: "url(#uv_svg2__d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.18 105.88H5.88C2.63 105.88 0 103.24 0 100s2.63-5.88 5.88-5.88h15.3c3.25 0 5.88 2.63 5.88 5.88s-2.63 5.88-5.88 5.88",
    style: {
      fill: "url(#uv_svg2__e)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.6 37.62c-2.03 0-4-1.05-5.09-2.94l-7.65-13.25a5.873 5.873 0 0 1 2.15-8.03 5.87 5.87 0 0 1 8.03 2.15l7.65 13.25c1.63 2.81.66 6.41-2.15 8.03-.93.54-1.94.79-2.93.79",
    style: {
      fill: "url(#uv_svg2__f)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.07 187.39c-2.03 0-4-1.05-5.09-2.94l-7.65-13.25a5.873 5.873 0 0 1 2.15-8.03 5.87 5.87 0 0 1 8.03 2.15l7.65 13.25c1.63 2.81.66 6.41-2.15 8.03-.93.54-1.94.79-2.93.79",
    style: {
      fill: "url(#uv_svg2__g)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.26 66.47c-2.03 0-4.01-1.05-5.1-2.94-1.62-2.81-.66-6.41 2.15-8.03l13.25-7.65c2.81-1.62 6.41-.66 8.03 2.15s.66 6.41-2.15 8.03l-13.25 7.65c-.93.54-1.94.79-2.93.79",
    style: {
      fill: "url(#uv_svg2__h)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.49 152.94c-2.03 0-4-1.05-5.09-2.94a5.873 5.873 0 0 1 2.15-8.03l13.25-7.65a5.87 5.87 0 0 1 8.03 2.15c1.63 2.81.66 6.41-2.15 8.03l-13.25 7.65c-.93.54-1.94.79-2.93.79",
    style: {
      fill: "url(#uv_svg2__i)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.74 66.47c-1 0-2.01-.25-2.93-.79l-13.25-7.65A5.87 5.87 0 0 1 13.41 50c1.62-2.81 5.21-3.77 8.03-2.15l13.25 7.65a5.87 5.87 0 0 1 2.15 8.03 5.88 5.88 0 0 1-5.09 2.94",
    style: {
      fill: "url(#uv_svg2__j)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.51 152.94c-1 0-2.01-.25-2.93-.79l-13.25-7.65c-2.81-1.62-3.77-5.21-2.15-8.03a5.873 5.873 0 0 1 8.03-2.15l13.25 7.65a5.87 5.87 0 0 1 2.15 8.03 5.89 5.89 0 0 1-5.1 2.94",
    style: {
      fill: "url(#uv_svg2__k)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.4 37.62c-1 0-2.01-.25-2.93-.79-2.81-1.62-3.77-5.21-2.15-8.03l7.65-13.25A5.873 5.873 0 0 1 150 13.4c2.81 1.62 3.77 5.21 2.15 8.03l-7.65 13.25a5.88 5.88 0 0 1-5.09 2.94",
    style: {
      fill: "url(#uv_svg2__l)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.93 187.39c-1 0-2.01-.25-2.93-.79-2.81-1.62-3.77-5.21-2.15-8.03l7.65-13.25a5.87 5.87 0 0 1 8.03-2.15c2.81 1.62 3.77 5.21 2.15 8.03l-7.65 13.25a5.88 5.88 0 0 1-5.09 2.94",
    style: {
      fill: "url(#uv_svg2__m)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.71 124.24a6.72 6.72 0 0 1-6.32-4.45l-12.58-36.23c-1.06-3.07.56-6.42 3.63-7.48 3.06-1.07 6.41.56 7.48 3.62l7.68 22.13 7.31-21.99c1.02-3.08 4.35-4.74 7.43-3.73a5.88 5.88 0 0 1 3.73 7.43l-11.99 36.1c-.94 2.74-3.47 4.56-6.31 4.59h-.05Z",
    style: {
      fill: "url(#uv_svg2__n)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.07 124.24h-.04c-3.62 0-6.96-.97-9.92-2.86-5.63-3.59-8.47-8.47-8.47-14.47V81.64c0-3.24 2.63-5.88 5.88-5.88s5.88 2.63 5.88 5.88v25.27c0 1.38.23 2.77 3.05 4.57 1.06.68 2.24 1.01 3.61 1.01h.02c1.27 0 2.38-.25 3.39-.76 3.25-1.63 3.69-3.3 3.69-4.85V81.63c0-3.24 2.63-5.88 5.88-5.88s5.88 2.63 5.88 5.88v25.25c0 6.6-3.61 12.05-10.16 15.34-2.64 1.34-5.57 2.02-8.68 2.02",
    style: {
      fill: "url(#uv_svg2__o)"
    }
  }));
};
export default SvgUv;